import {
    SET_MACRO_INDICATORS,
    ADD_MACRO_INDICATOR,
    UPDATE_MACRO_INDICATOR,
    DELETE_MACRO_INDICATOR,
    CLEAR_MACRO_INDICATORS,
    SET_FUEL_DATA,
    ADD_FUEL,
    UPDATE_FUEL,
    DELETE_FUEL,
    CLEAR_FUEL_DATA,
} from "../actiontypes";

// Macro Indicators Actions
export const setMacroIndicators = (payload) => ({
    type: SET_MACRO_INDICATORS,
    payload,
});

export const addMacroIndicator = (payload) => ({
    type: ADD_MACRO_INDICATOR,
    payload,
});

export const updateMacroIndicator = (payload) => ({
    type: UPDATE_MACRO_INDICATOR,
    payload,
});

export const deleteMacroIndicator = (id) => ({
    type: DELETE_MACRO_INDICATOR,
    payload: { id },
});

export const clearMacroIndicators = () => ({
    type: CLEAR_MACRO_INDICATORS,
});

// Fuel Data Actions
export const setFuelData = (payload) => ({
    type: SET_FUEL_DATA,
    payload,
});

export const addFuel = (payload) => ({
    type: ADD_FUEL,
    payload,
});

export const updateFuelAction = (payload) => ({
    type: UPDATE_FUEL,
    payload,
});

export const deleteFuelAction = (uuid) => ({
    type: DELETE_FUEL,
    payload: { uuid },
});

export const clearFuelData = () => ({
    type: CLEAR_FUEL_DATA,
});